const ALLOWED_MIME_TYPES = new Set(['image/svg+xml', 'image/png', 'image/jpeg', 'image/webp']);
const ALLOWED_EXTENSIONS = new Set(['.svg', '.png', '.jpg', '.jpeg', '.webp']);

const extensionOf = (filename: string): string => {
  const dot = filename.lastIndexOf('.');
  return dot >= 0 ? filename.slice(dot).toLowerCase() : '';
};

export type ImageUploadErrorCode = 'invalidType' | 'tooLarge' | 'readFailed';

export class ImageUploadError extends Error {
  readonly code: ImageUploadErrorCode;

  readonly labelKey: string;

  readonly maxKb?: number;

  constructor(code: ImageUploadErrorCode, labelKey: string, maxKb?: number) {
    super(code);
    this.name = 'ImageUploadError';
    this.code = code;
    this.labelKey = labelKey;
    this.maxKb = maxKb;
  }
}

export const readImageUpload = (
  file: File,
  maxBytes: number,
  labelKey = 'editor.uploadLabels.image',
): Promise<string> =>
  new Promise((resolve, reject) => {
    const extension = extensionOf(file.name);
    if (!ALLOWED_EXTENSIONS.has(extension) && !ALLOWED_MIME_TYPES.has(file.type)) {
      reject(new ImageUploadError('invalidType', labelKey));
      return;
    }
    if (file.size > maxBytes) {
      reject(new ImageUploadError('tooLarge', labelKey, Math.round(maxBytes / 1024)));
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result !== 'string') {
        reject(new ImageUploadError('readFailed', labelKey));
        return;
      }
      resolve(reader.result);
    };
    reader.onerror = () => reject(new ImageUploadError('readFailed', labelKey));
    reader.readAsDataURL(file);
  });

export const MAX_SLIDE_IMAGE_BYTES = 2 * 1024 * 1024;
